import { Camera } from "lucide-react";
import { INTERVENTION_PHOTOS } from "../lib/constants";

export default function InterventionsGallery() {
  return (
    <section
      data-testid="interventions-gallery"
      className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28"
    >
      <div className="mb-12 max-w-2xl">
        <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-teal-700 mb-3">
          <Camera className="w-4 h-4" /> Nos réalisations
        </div>
        <h2 className="font-display text-3xl md:text-5xl font-extrabold tracking-tight text-slate-900 leading-tight">
          Quelques photos
          <br />
          <span className="text-teal-600">de nos interventions.</span>
        </h2>
        <p className="text-slate-600 mt-4 leading-relaxed">
          Un aperçu concret de notre travail : précision, finition et matériel
          de qualité sur chaque chantier.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {INTERVENTION_PHOTOS.map((p, i) => (
          <figure
            key={i}
            data-testid={`intervention-photo-${i + 1}`}
            className="group relative overflow-hidden rounded-3xl border border-slate-200 bg-slate-100"
          >
            <div className="relative overflow-hidden aspect-[4/5]">
              <img
                src={p.url}
                alt={p.caption}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-slate-900/70 via-slate-900/10 to-transparent opacity-90" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-5">
                <div className="text-[10px] font-bold uppercase tracking-widest text-teal-300 mb-1">
                  Intervention 0{i + 1}
                </div>
                <div className="font-display text-lg md:text-xl font-bold text-white leading-tight">
                  {p.caption}
                </div>
              </figcaption>
            </div>
          </figure>
        ))}
      </div>
    </section>
  );
}
